import { createFeatureSelector, createSelector } from "@ngrx/store";
import { pumpSystemFeatureKey } from "./pump-system.reducer";

export const selectPumpSystemState = createFeatureSelector(pumpSystemFeatureKey);

export const selectPumpSystem = createSelector(
  selectPumpSystemState,
  (state: any) => state
);
